/* eslint-disable  @typescript-eslint/no-unused-expressions*/
import React, { useEffect, useReducer } from 'react';
import queryString from 'query-string';
import style from './CabsLanding.module.css';
import {
  CAB_FROM_AIRPORT,
  CAB_TO_AIRPORT,
  OUTSTATION_ONE_WAY,
  OUTSTATION_ROUND_TRIP,
  RENTALS,
  getCabLandingShortCodeFromTripType,
  isAirportCheck
} from '../../constants/tripTypes';
import '../../components/CabModifySearch/CabModifySearch.css';
import '../../components/CabDatePicker/CabDayPicker.css';
import 'react-day-picker/lib/style.css';
import '../../components/CabDatePicker/DayPickerCabReset.css';
import { Package } from '../runtime-typechecker';
import CabsTripTypes from './components/triptypes/CabsTripTypes';
import {
  SEO_CABS_LANDING_PAGE,
  SEO_LANDING
} from '../../constants/templateConstants';
import {
  AirportCityLocationInput,
  AirportLocationInput,
  DestinationLocationInput,
  RentalLocationInput,
  SourceLocationInput
} from './components/LocationInputSection';
import { DateInputBasedOnTrip } from './components/DateInput';
import { RentalPackageInput } from './components/RentalPackageInput';
import { RentalPackages } from './components/RentalPackages';
import { TripTypeOptions } from './components/TripTypeOptions';
import { TripTypeInfo } from './components/TripTypeInfo';
import { CabInfo } from './components/CabInfo';
import { Footer } from './components/Footer';
import { SwapIcon } from './components/SwapIcon/SwapIcon';
import { cabsLandingWidgetInfo } from '../../../src/cabsLandingWidgetInfo';
import Helmet from 'react-helmet';
import { AppDownloadBanner } from '../../components/AppDownloadBanner';
import {
  AdsScrollComponent,
  SnackBarComponent
} from './components/AdsComponent';
import { BusHireComponent } from './components/BusHireComponent';
import {
  SET_WIDGET,
  reducer,
  getInitialState,
  SET_DROP_WIDGET_OPEN
} from './cabsLandingPageState';
import { CABS_LANDING_PAGE_SNACKBAR_CONTEXT_ID } from '../../constants/adsConfig';
import { showSnackBar } from '../../pokusUtil';
import { useInitApiData } from './customHooks';
import {
  FromAirportSearch,
  OutStationSearch,
  RentalSearch,
  StopOverSearch,
  ToAirportSearch
} from './components/LocationSearch/LocationSearch';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../CabsLandingContext';
import { StopOvers } from './components/StopOvers';
import { getCabConfiguration } from '../../cabsLandingAPIs';
import { OfferSection } from './components/OfferSection/OfferSection';
import { WhatsNew } from './components/WhatsNew/WhatsNew';
import { MySafetySection } from './components/MySafetySection/MySafetySection';
import { SearchButton } from './components/SearchCabButton/SearchButton';
import { StopOverAdd } from './components/StopOverAdd';
import DateAndTime from './components/DateTimeWidget/DateTimeWidget';
import { getAppEnv } from '../../../config/env';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const CabsLandingPage = ({ data }) => {
  const { templateData, selectedTripType, cabConfigData } = data;
  const { commonInfo, footerLinks, h1Title } = templateData;

  const getRentalPackages = (): Package[] => {
    return cabConfigData?.response?.package_duration_filter || [];
  };

  const { userData, cabLandingPlaceHolderConfigData } = useInitApiData();

  const [cabsLandingState, dispatch] = useReducer(
    reducer,
    getInitialState({
      selectedTripType: selectedTripType,
      useLS: true,
      packages: getRentalPackages()
    })
  );

  const getCabCard = cardType => {
    if (!cabLandingPlaceHolderConfigData) return null;
    return cabLandingPlaceHolderConfigData.response.filter(
      ({ type }) => type === cardType
    );
  };

  const getCabCardContextIds = () => {
    const adCard = getCabCard('ADS');
    if (!adCard?.length) return null;
    return adCard[0]?.context_ids;
  };

  const showBusHireCard = () => {
    const adCard = getCabCard('BUS_HIRE');
    if (!adCard?.length) return false;
    return true;
  };

  const getMySafetyInfo = () => {
    const mySafety = getCabCard('MYSAFETY');
    if (!mySafety?.length) return null;
    return mySafety[0];
  };

  const getWhatsNewInfo = () => {
    const whatsNewCard = getCabCard('WHATS_NEW');
    if (!whatsNewCard?.length) return null;
    return whatsNewCard[0];
  };

  const adContextIds = getCabCardContextIds();

  const {
    widget,
    airport,
    airportCity,
    travelFor,
    sourceCity,
    destinationCity,
    stopOvers,
    dropWidgetOpen
  } = cabsLandingState;

  const setWidget = widgetNumber => {
    dispatch({ type: SET_WIDGET, newStateValue: widgetNumber });
  };

  const closePopup = () => {
    setWidget(null);
    setIsDropWidgetClicked(false);
  };

  const setIsDropWidgetClicked = value => {
    dispatch && dispatch({ type: SET_DROP_WIDGET_OPEN, newStateValue: value });
  };

  const goBack = () => {
    window?.history?.back();
  };

  const getQueryParamsSeparatedUrl = (): {
    url: string | null;
    parameters: string | null;
  } => {
    try {
      const urlSplits = window?.location?.href?.split('?');
      if (urlSplits.length > 1) {
        let parameters = urlSplits[1];
        parameters = parameters.replace(/tripType=[a-zA-Z0-9]{1,3}&?/, '');
        return { url: urlSplits[0], parameters: parameters };
      } else {
        return { url: urlSplits[0], parameters: null };
      }
    } catch (ex) {
      return { url: null, parameters: null };
    }
  };
  useEffect(() => {
    const { url, parameters } = getQueryParamsSeparatedUrl();
    if (url) {
      window.history.replaceState(
        null,
        'changed trip type',
        `${url}?tripType=${getCabLandingShortCodeFromTripType(travelFor)}${
          parameters ? `&${parameters}` : ``
        }`
      );
    }
  }, [travelFor]);

  const widgetMap = new Map<number, JSX.Element>();
  // hr package 6
  widgetMap.set(
    cabsLandingWidgetInfo.HR_PACKAGES_WIDGET,
    <React.Fragment>
      <RentalPackages style={style} />
    </React.Fragment>
  );
  // out station pick up 7
  widgetMap.set(
    cabsLandingWidgetInfo.OUTSTATION_PICKUP_LOCATION_WIDGET,
    <React.Fragment>
      <div className="rsw_autocomplePopup">
        <OutStationSearch />
      </div>
      <div className="hsBackDrop" onClick={closePopup}></div>
    </React.Fragment>
  );

  // out station drop 8
  widgetMap.set(
    cabsLandingWidgetInfo.OUTSTATION_DROP_LOCATION_WIDGET,
    <React.Fragment>
      <div className="rsw_autocomplePopup">
        <OutStationSearch />
      </div>
      <div className="hsBackDrop" onClick={closePopup}></div>
    </React.Fragment>
  );

  // rental pick up 9
  widgetMap.set(
    cabsLandingWidgetInfo.RENTAL_PICKUP_LOCATION_WIDGET,
    <React.Fragment>
      <div className="rsw_autocomplePopup">
        <RentalSearch />
        <div className="hsBackDrop" onClick={closePopup}></div>
      </div>
    </React.Fragment>
  );
  // from airport
  widgetMap.set(
    cabsLandingWidgetInfo.FROM_AIRPORT_LOCATION_WIDGET,
    <React.Fragment>
      <div className="rsw_autocomplePopup">
        <FromAirportSearch />
      </div>
      <div className="hsBackDrop" onClick={closePopup}></div>
    </React.Fragment>
  ),
    widgetMap.set(
      cabsLandingWidgetInfo.FROM_AIRPORT_CITY_LOCATION_WIDGET,
      <React.Fragment>
        <div className="rsw_autocomplePopup">
          <FromAirportSearch />
        </div>
        <div className="hsBackDrop" onClick={closePopup}></div>
      </React.Fragment>
    );
  // from airport
  widgetMap.set(
    cabsLandingWidgetInfo.TO_AIRPORT_LOCATION_WIDGET,
    <React.Fragment>
      <div className="rsw_autocomplePopup">
        <ToAirportSearch />
      </div>
      <div className="hsBackDrop" onClick={closePopup}></div>
    </React.Fragment>
  ),
    widgetMap.set(
      cabsLandingWidgetInfo.TO_AIRPORT_CITY_LOCATION_WIDGET,
      <React.Fragment>
        <div className="rsw_autocomplePopup">
          <ToAirportSearch />
        </div>
        <div className="hsBackDrop" onClick={closePopup}></div>
      </React.Fragment>
    );
  // airport city  11
  widgetMap.set(
    cabsLandingWidgetInfo.STOPOVER_CITY_LOCATION_WIDGET,
    <React.Fragment>
      <div className="rsw_autocomplePopup">
        <StopOverSearch />
      </div>
    </React.Fragment>
  );
  widgetMap.set(
    cabsLandingWidgetInfo.NEW_DATE_TIME_PICKER,
    <React.Fragment>
      <div className="rsw_autocomplePopup">
        <DateAndTime onClick={closePopup} dropWidgetOpen={dropWidgetOpen} />
      </div>
    </React.Fragment>
  );

  return (
    <CabsLandingContext.Provider value={cabsLandingState}>
      <CabsLandingDispatchContext.Provider value={dispatch}>
        <div
          id="cabLandingPage"
          className={`${widget != null ? `${style.fixed}` : ''}`}
        >
          <Helmet>
            <title>{templateData.metaTitle}</title>
            <meta name="description" content={templateData.metaDescription} />
            <meta name="keywords" content={templateData.metaKeywords} />
            <meta name="ROBOTS" content={templateData.metaRobots} />
            <link rel="canonical" href={templateData.sampleUrl} />
            {/* <link rel="alternate" href={templateData.alternate} /> */}
          </Helmet>
          <div
            style={{ position: 'sticky', top: 0, zIndex: 7 }}
            className="whiteBackGroundColor  noTouchAction"
          >
            <AppDownloadBanner templateName={templateData.templateName} />
            <div
              onClick={closePopup}
              className={`${widget != null ? `${style.blackOverlay}` : ''}`}
            ></div>
            <div style={{ paddingTop: '5px' }} className="makeFlex">
              <div
                onClick={() => {
                  goBack();
                }}
                style={{
                  width: '20%',
                  height: 48,
                  backgroundColor: '#ffffff',
                  border: 'none'
                }}
                className={`makeFlex ${style.goBack}`}
              >
                <img
                  src={`${PUBLIC_URL}/static/public/back_arrow.webp`}
                  width={16}
                  height={16}
                  className="vertlCenter horizontalCenter"
                />
              </div>
              <h1
                className="font18 latoBold blackText makeFlex hrtlCenter horizontalCenter textNoWrap"
                style={{ height: '48px' }}
              >
                {` ${h1Title}`}
              </h1>
              <div style={{ width: '20%' }} className="makeFlex"></div>
            </div>
            <div
              style={{
                height: '42px',
                marginTop: '4px',
                marginBottom: '-30px',
                boxShadow: 'rgba(0, 0, 0, 0.2) 0px 5px 2.5px'
              }}
            ></div>
            <CabsTripTypes />
          </div>

          <div
            style={{
              paddingLeft: '16px',
              paddingRight: '16px',
              paddingBottom: '16px',
              paddingTop: '20px'
            }}
            className="whiteBackGroundColor"
          >
            <TripTypeInfo />
            <TripTypeOptions style={style} />
            {travelFor === OUTSTATION_ROUND_TRIP ||
            travelFor === OUTSTATION_ONE_WAY ? (
              <>
                <SourceLocationInput widgetMap={widgetMap} />
                {
                  <SwapIcon
                    showIcon={
                      sourceCity && destinationCity && stopOvers.length === 0
                    }
                    imageStyleObject={{ top: '-13px', right: '20px' }}
                  />
                }
                <StopOvers widgetMap={widgetMap} />
                <DestinationLocationInput widgetMap={widgetMap} />
              </>
            ) : null}
            {isAirportCheck(travelFor) ? (
              <>
                {travelFor === CAB_FROM_AIRPORT ? (
                  <>
                    <AirportLocationInput
                      widgetMap={widgetMap}
                      widgetNumber={
                        cabsLandingWidgetInfo.FROM_AIRPORT_LOCATION_WIDGET
                      }
                    />
                    <SwapIcon
                      showIcon={airport && airportCity}
                      imageStyleObject={{ top: '-13px', right: '20px' }}
                    />
                    <AirportCityLocationInput
                      widgetMap={widgetMap}
                      widgetNumber={
                        cabsLandingWidgetInfo.FROM_AIRPORT_CITY_LOCATION_WIDGET
                      }
                    />
                  </>
                ) : null}
                {travelFor === CAB_TO_AIRPORT ? (
                  <>
                    <AirportCityLocationInput
                      widgetMap={widgetMap}
                      widgetNumber={
                        cabsLandingWidgetInfo.TO_AIRPORT_CITY_LOCATION_WIDGET
                      }
                    />
                    <SwapIcon
                      showIcon={airport && airportCity}
                      imageStyleObject={{ top: '-13px', right: '20px' }}
                    />
                    <AirportLocationInput
                      widgetMap={widgetMap}
                      widgetNumber={
                        cabsLandingWidgetInfo.TO_AIRPORT_LOCATION_WIDGET
                      }
                    />
                  </>
                ) : null}
              </>
            ) : null}
            {travelFor === RENTALS ? (
              <RentalLocationInput widgetMap={widgetMap} />
            ) : null}
            <StopOverAdd />
            <DateInputBasedOnTrip
              widgetComponent={widgetMap.get(
                cabsLandingWidgetInfo.NEW_DATE_TIME_PICKER
              )}
              setIsDropWidgetClicked={setIsDropWidgetClicked}
            />
            {travelFor == RENTALS ? (
              <>
                <RentalPackageInput
                  widgetComponent={widgetMap.get(
                    cabsLandingWidgetInfo.HR_PACKAGES_WIDGET
                  )}
                />
              </>
            ) : null}
            <SearchButton />
          </div>
          <OfferSection />
          <div
            style={{
              paddingTop: '10px'
            }}
          >
            {showSnackBar() && (
              <SnackBarComponent uuid={CABS_LANDING_PAGE_SNACKBAR_CONTEXT_ID} />
            )}
          </div>
          <AdsScrollComponent style={style} uuid={adContextIds} />
          <WhatsNew whatsNewInfo={getWhatsNewInfo()} />
          <div
            style={{
              paddingLeft: '16px',
              paddingRight: '16px'
            }}
          >
            <BusHireComponent showBusHire={showBusHireCard()} />
          </div>
          <MySafetySection mySafetyInfo={getMySafetyInfo()} />
          <CabInfo commonInfo={commonInfo} style={style} />
          <Footer footerLinks={footerLinks} />
          <div style={{ height: 60, position: 'sticky', zIndex: '7' }}></div>
        </div>
      </CabsLandingDispatchContext.Provider>
    </CabsLandingContext.Provider>
  );
};

CabsLandingPage.fetchData = async (_, match, urlObj) => {
  const queryParam = queryString.parse(urlObj.search);
  let tripType;
  if (queryParam) {
    tripType = queryParam.tripType;
  }
  const responseData = {
    selectedTripType: tripType
  };

  let cacheKey = 'HTML_STATIC_CABS_';
  if (tripType) {
    cacheKey = cacheKey + `?TRIPTYPE=${tripType}`;
  }

  // needs to be  in  a separate file or done differently,
  const templateData = {
    templateName: SEO_CABS_LANDING_PAGE,
    metaTitle:
      'Online Cab Booking - Book Outstation Cabs at Lowest Fare @ MakeMyTrip',
    metaRobots: 'INDEX, FOLLOW',
    metaDescription:
      'Book a cab for outstation at best price, Get fastest taxi service available in all the top Indian cities. Available all type of Cabs- SUV, Sedan, Hatchback at MakeMyTrip.com',
    metaKeywords: 'Cab Booking Online, Outstation Cab',
    analytics: `var s=s_gi('mmtprod');
      s.pageName="landing:domestic cabs:landing-New";
      s.channel="landing";
      s.prop69='${SEO_LANDING}'
      s.server = window.location.hostname;
      s.prop24="domestic cabs";
      if(typeof(mboxLoadSCPlugin) != "undefined" ){
      mboxLoadSCPlugin(s);
      }
      var s_code=s.t();if(s_code)document.write(s_code);`,
    h1Title: 'Online Cab Booking',
    extraInfo: '',
    externalJs: '',
    sampleUrl: 'https://www.makemytrip.com/cabs/',
    // alternate: 'https://cabs.makemytrip.com',
    footerData: '',
    footerLinks: {
      'Product Offering': {
        iconUrl: '',
        links: [
          {
            text: 'Flights',
            id: 'flights',
            onclickUrl: 'https://www.makemytrip.com/flights/'
          },
          {
            text: 'International Flights',
            onclickUrl: 'https://www.makemytrip.com/international-flights/',
            id: 'international-flights'
          },
          {
            text: 'Charter Flights',
            onclickUrl: 'https://www.makemytrip.com/charter-flights/',
            id: 'charter-flights'
          },
          {
            text: 'Hotels',
            onclickUrl: 'https://www.makemytrip.com/hotels/',
            id: 'hotels'
          },
          {
            text: 'International Hotels',
            onclickUrl: 'https://www.makemytrip.com/hotels-international/',
            id: 'international-hotels'
          },
          {
            text: 'Homestays and Villas',
            onclickUrl: 'https://www.makemytrip.com/homestays/',
            id: 'homestays-and-villas'
          },
          {
            text: 'Activities',
            onclickUrl: 'https://www.makemytrip.com/activities/'
          },
          {
            text: 'Holidays In India',
            onclickUrl: 'https://www.makemytrip.com/holidays-india',
            id: 'holidays-in-india'
          },
          {
            text: 'International Holidays',
            onclickUrl: 'https://www.makemytrip.com/holidays-international',
            id: 'international-holidays'
          },
          {
            text: 'Book Hotels From UAE',
            onclickUrl: 'https://www.makemytrip.com/hotels/?ccde=ae',
            id: 'book-hotels-from-uae'
          },
          {
            text: 'myBiz for Corporate Travel',
            onclickUrl:
              'https://mybiz.makemytrip.com/?intid=mmtfooter_productoffering',
            id: 'mybiz-for-corporate-travel'
          },
          {
            text: 'Book Online Cabs',
            onclickUrl: 'https://www.makemytrip.com/cabs',
            id: 'cabs'
          },
          {
            text: 'Book Bus Tickets',
            onclickUrl: 'https://www.makemytrip.com/bus-tickets/',
            id: 'bus-tickets'
          },
          {
            text: 'Book Train Tickets',
            onclickUrl: 'https://www.makemytrip.com/railways/',
            id: 'train-tickets'
          },
          {
            text: 'Cheap Tickets to India',
            onclickUrl: 'https://www.makemytrip.com/?ccde=us',
            id: 'cheap-tickets-to-india'
          },
          {
            text: 'Book Flights From US',
            onclickUrl: 'https://www.makemytrip.com/flights/?ccde=us',
            id: 'book-flights-from-us'
          },
          {
            text: 'Book Flights From UAE',
            onclickUrl: 'https://www.makemytrip.com/flights/?ccde=us',
            id: 'book-flights-from-uae'
          },
          {
            text: 'Trip Planner',
            onclickUrl:
              'https://planner.makemytrip.com/?&intid=Homepage_Tab_Inspirock',
            id: 'trip-planner'
          },
          {
            text: 'Gift Cards',
            onclickUrl: 'https://www.makemytrip.com/gift-cards',
            id: 'gift-vouchers'
          },
          {
            text: 'Trip Money',
            onclickUrl: 'https://www.tripmoney.com/',
            id: 'trip-money'
          },
          {
            text: 'Trip Ideas',
            onclickUrl: 'https://www.makemytrip.com/tripideas/',
            id: 'trip-ideas'
          },
          {
            text: 'Travel Blog',
            onclickUrl: 'https://www.makemytrip.com/blog/?intid=mmtblog_footer',
            id: 'travel-blog'
          },
          {
            text: 'PNR Status',
            onclickUrl: 'https://www.makemytrip.com/railways/PNR/',
            id: 'pnr-status'
          },
          {
            text: 'MakeMyTrip Advertising Solutions',
            onclickUrl: 'https://advertising.makemytrip.com/ad/solutions/',
            id: 'makemytrip-advertising-solutions'
          },
          {
            text: 'One Way Cab',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/one-way-cab.html',
            id: 'one-way-cab'
          }
        ]
      },
      MakeMyTrip: {
        iconUrl: '',
        links: [
          {
            text: 'About Us',
            onclickUrl:
              'https://www.makemytrip.com/about-us/company_profile.php',
            id: 'about-us'
          },
          {
            text: 'Investor Relations',
            onclickUrl: 'https://investors.makemytrip.com',
            id: 'investor-relations'
          },
          {
            text: 'Careers',
            onclickUrl: 'https://www.makemytrip.com/about-us/jobs.php',
            id: 'careers'
          },
          {
            text: 'MMT Foundation',
            onclickUrl: 'https://www.makemytrip.com/csr/mmt_foundation.html',
            id: 'mmt-foundation'
          },
          {
            text: 'CSR Policy',
            onclickUrl: 'https://www.makemytrip.com/csr/csr_policy.html',
            id: 'csr-policy'
          },
          {
            text: 'myPartner - Travel Agent Portal',
            onclickUrl: 'https://mypartner.makemytrip.com',
            id: 'mypartner---travel-agent-portal'
          },
          {
            text: 'Foreign Exchange',
            onclickUrl: 'https://www.fxkart.com/makemytrip?utm_source=MMTAFF',
            id: 'foreign-exchange'
          },
          {
            text: 'List your hotel',
            onclickUrl:
              'https://www.makemytrip.com/hotels/hotelier-register.htm',
            id: 'list-your-hotel'
          },
          {
            text: 'Partners- Redbus',
            onclickUrl: 'https://www.redbus.in/bus-tickets',
            id: 'redbus'
          },
          {
            text: 'Partners- Goibibo',
            onclickUrl: 'https://www.goibibo.com/',
            id: 'goibibo'
          },
          {
            text: 'Advertise with Us',
            onclickUrl: 'https://advertising.makemytrip.com/ad/solutions/',
            id: 'advertise-with-us'
          }
        ]
      },
      'About the Site': {
        iconUrl: '',
        links: [
          {
            text: 'Customer Support',
            onclickUrl:
              'https://supportz.makemytrip.com/Mima/CustomerHelpAndSupport/',
            id: 'customer-support'
          },
          {
            text: 'Payment Security',
            onclickUrl:
              'https://www.makemytrip.com/legal/payment_security.html',
            id: 'payment-security'
          },
          {
            text: 'Privacy Policy',
            onclickUrl:
              '`https://www.makemytrip.com/legal${urlParam}/privacy_policy.html`',
            id: 'privacy-policy'
          },
          {
            text: 'User Agreement',
            onclickUrl:
              '`https://www.makemytrip.com/legal${urlParam}/user_agreement.html`',
            id: 'user-agreement'
          },
          {
            text: 'Terms of Service',
            onclickUrl:
              '`https://www.makemytrip.com/legal${urlParam}/user_agreement.html#tos`',
            id: 'terms-of-service'
          },
          {
            text: 'More Offices',
            onclickUrl: 'https://www.makemytrip.com/support/branch-offices.php',
            id: 'more-offices'
          },
          {
            text: 'Make A Payment',
            onclickUrl: 'https://payments.makemytrip.com/easypay/',
            id: 'make-a-payment'
          },
          {
            text: 'Work From Home',
            onclickUrl:
              'https://www.makemytrip.com/about-us/work-from-home.php',
            id: 'work-from-home'
          }
        ]
      },
      'Important Links': {
        iconUrl: '',
        links: [
          {
            text: 'Mumbai to Vadodara Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/mumbai-baroda-cab-services.html'
          },
          {
            text: 'Mumbai to Pune Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/mumbai-pune-cab-services.html'
          },
          {
            text: 'Mumbai to Nashik Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/mumbai-nashik-cab-services.html'
          },
          {
            text: 'Nashik to Mumbai Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/nasik-mumbai-cab-services.html'
          },
          {
            text: 'Pune to Mumbai Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/pune-mumbai-cab-services.html'
          },
          {
            text: 'Delhi to Manali Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/delhi-manali-cab-services.html'
          },
          {
            text: 'Delhi to Chandigarh Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/delhi-chandigarh-cab-services.html'
          },
          {
            text: 'Pune to Shirdi Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/pune-shirdi-cab-services.html'
          },
          {
            text: 'Delhi to Jaipur Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/delhi-jaipur-cab-services.html'
          },
          {
            text: 'Mumbai to Surat Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/mumbai-surat-cab-services.html'
          },
          {
            text: 'Pune to Nashik Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/pune-nasik-cab-services.html'
          },
          {
            text: 'Chandigarh to Manali Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/chandigarh-manali-cab-services.html'
          },
          {
            text: 'Delhi to Shimla Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/new_delhi-shimla-cab-services.html'
          },
          {
            text: 'Pune to Lonavala Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/pune-lonavala-cab-services.html'
          },
          {
            text: 'Shimla to Chandigarh Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/shimla-chandigarh-cab-services.html'
          },
          {
            text: 'Agra to Delhi Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/agra-delhi-cab-services.htmll'
          },
          {
            text: 'Delhi to Agra Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/delhi-agra-cab-services.html'
          },
          {
            text: 'Kanpur to Lucknow Cabs',
            onclickUrl:
              'hhttps://www.makemytrip.com/car-rental/kanpur-lucknow-cab-services.html'
          },
          {
            text: 'Mumbai to Shirdi Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/mumbai-shirdi-cab-services.html'
          },
          {
            text: 'Mysore to Bangalore Cabs',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/mysore-bangalore-cab-services.html'
          }
        ]
      },
      'Quick Links': {
        iconUrl: '',
        links: [
          {
            text: 'Taxi Services in Bangalore',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/bangalore-city-cabs.html'
          },
          {
            text: 'Taxi Services in Chennai',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/chennai-city-cabs.html'
          },
          {
            text: 'Taxi Services in Delhi',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/delhi-city-cabs.html'
          },
          {
            text: 'Taxi Services in Hyderabad',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/hyderabad-city-cabs.html'
          },
          {
            text: 'Taxi service in Ahmedabad',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/ahmedabad-city-cabs.html'
          },
          {
            text: 'Taxi Services in Gurgaon',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/gurgaon-city-cabs.html'
          },
          {
            text: 'Taxi Services in Chandigarh',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/chandigarh-city-cabs.html'
          },
          {
            text: 'Taxi Services in Mumbai',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/mumbai-city-cabs.html'
          },
          {
            text: 'Taxi Services in Jaipur',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/jaipur-city-cabs.html'
          },
          {
            text: 'Taxi Services in Pune',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/pune-city-cabs.html'
          },
          {
            text: 'Taxi Services in Haridwar',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/haridwar-city-cabs.html'
          },
          {
            text: 'Taxi Services in Udaipur',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/udaipur-city-cabs.html'
          },
          {
            text: 'Taxi Services in Lucknow',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/lucknow-city-cabs.html'
          },
          {
            text: 'Taxi Services in Shimla',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/shimla-city-cabs.html'
          },
          {
            text: 'Taxi Services In Dharamshala',
            onclickUrl:
              'https://www.makemytrip.com/car-rental/dharamshala-city-cabs.html'
          }
        ]
      }
    },
    commonInfo: {
      content: [
        {
          header: 'Online Cab Booking Made Easy',
          para:
            'Traveling to different destinations and exploring unknown places is the most fantastic feeling. People have recently started traveling a lot more than they used to. Moreover, there has been a surge in tourists who are taking road trips. One can simply make an <b>online cab booking</b> and travel to any part of the country. As more offbeat places are coming to limelight, travel enthusiasts are constantly in a rush to explore those hidden gems. Road trips are always fun and exciting as you not only enjoy the destination but also the journey. While on a road trip, you can enjoy the scenic landscapes, beautiful lanes, and fascinating sights throughout the journey. Choosing the right cab service makes all the difference. MakeMyTrip wants you to enjoy road trips without the stress of driving to long distances yourself. Whether you are planning a solo trip, a weekend getaway with friends, or a fun vacation with your family, MakeMyTrip can make your journey smooth. All you need to do is choose your preferred destination and make an <b>online taxi booking</b> with MakeMyTrip. The easy-to-navigate interface of MakeMyTrip ensures that you can make your booking within a few minutes.'
        },
        {
          header: 'Ensure a Safe and Secure Trip',
          para:
            'When it comes to travelling, safety is always the topmost priority. A comfortable and secure journey can make a trip memorable. You can find the top-rated car rental services on MakeMyTrip that ensure a safe trip to your destination. While booking a cab on MakeMyTrip, you do not need to worry about the car routes, car hygiene, or pricing. MakeMyTrip’s cab booking services are very effective and reliable. Moreover, availing a cab facility is pretty easy with the user-friendly app of MakeMyTrip. While you make your cab booking,  you can choose from a wide variety of options such as hatchbacks, sedans, or SUVs. Moreover, you will be picked from your location on time so that there are no delays in reaching the destination. Considering the current Covid-19 situation, all the safety measures are taken to ensure safe travel. The temperature of the drivers are checked before the journey. Moreover, the cab is sanitized before and after the journey. Not to mention, it is mandatory for passengers as well as drivers to wear their masks. GPS, safety alerts, and travel trackers are integrated in all the cars so that the passengers are well-informed about the drivers and the vehicle to avoid the last-minute hassle. '
        },
        {
          header: 'Cab Booking Services by MakeMyTrip',
          para:
            'We operate in all major cities in India and connect people from different parts of the cities. Whether you want to take an airport taxi, a cab to the nearest railway station or bus station, or want to visit a different city, MakeMyTrip offers you a seamless cab booking experience. We provide you with dedicated cabs and taxis, waiting at the priority lane of airports and railways for you to have a comfortable ride. We understand the importance of your time and money, and we make sure that you reach your destination on time. For making your cab booking, you simply need to visit the official website or app of MakeMyTrip. Then you have to enter all the required details such as the city of origin, the destination, your departure date and time. You must also select whether you are booking the cab for a one-way trip or a round trip. Once you have filled in all the required information, you just need to click on the ‘Search’ option. You will be redirected to a new page where you can find all the available cab options.'
        },
        {
          header: 'Book an Outstation Cab on MakeMyTrip',
          para:
            'Whether you wish to travel to popular tourist destinations such as Amritsar, Shimla and Agra or would like to explore the hidden gems of India, you can easily book outstation cab on MakeMyTrip. You can now book a one-way trip to your destination and enjoy your stay comfortably. If you want to explore the nearby cities, you can avail of services of our intercity car rentals category and choose among the top-rated chauffeurs for your vacation.  A trusted car rental service can offer a wide variety of cab options so that you can choose a car that suits your travel needs. You can also book outstation cab facility and let our executives guide you for a memorable travel experience. The charges differ from one cab to another and it depends on a lot of factors. For example, if you are choosing a 4-seater instead of a 6-seater, the charges of the former will be less than the latter. Moreover, the prices also depend on the distance covered and the in-car amenities provided to you. Not to mention, the charges on some special days such as during a festival or a national holiday might be higher than usual days. We also offer pickup and drop-off services, one-way as well as round trips, outstation trips, airport taxi transfers, and more. You can share your itinerary while making an online taxi booking with MakeMyTrip and enjoy a comfortable ride.'
        },
        {
          header: 'Special Offers and Discounts on MakeMyTrip',
          para:
            'MakeMyTrip has one of the most transparent and best pricing guaranteed models. We provide the best pricing in the market with no hidden charges. When you make an <b>online taxi booking</b> with us, we will inform you about every additional cost, toll charges, extra km charges, waiting charges, and other taxes. We believe in being totally transparent with our customers and provide them with accurate bills & invoices. With our <b>intercity car rental</b> service, you can avail of maximum benefits with our affordable and flexible hourly rental packages. We offer you top discounts, coupons, free rides, and cash backs on online cab booking services. We also provide priority car booking for our loyal customers. Now you can easily make a cab booking for a long trip or a short journey, a business trip, or a family vacation with the official app of MakeMyTrip or log in to the website. You can also connect with the 24/7 customer support service of MakeMyTrip and ride with the safest and trusted travel partners. MakeMyTrip is one of the leading <b>online cab booking</b> platforms in India. We connect people from over 1000+ cities in India with comfortable cab rides.'
        },
        {
          header: 'Why MakeMyTrip?',
          para:
            'The leading player in online cab bookings in India, MakeMyTrip offers great offers on cab fares, exclusive discounts and a seamless online booking experience. Cabs, Bus, Flight, hotel and holiday bookings through the desktop or mobile site is a delightfully customer friendly experience, and with just a few clicks you can complete your booking.'
        },
        {
          header: 'Booking Cabs with MakeMyTrip',
          para:
            "Book your cabs with India's leading online booking company since the year 2000. While booking cabs with MakeMyTrip, you can expect the ultimate online booking experience. With premium customer service, 24/7 dedicated helpline for support, and over 5 million delighted customers, MakeMyTrip takes great pride in enabling customer satisfaction. With a cheapest rates, book your cab at the lowest prices. Avail great offers, exclusive on app. <br><br>To enlist your fleet with us please contact at <a class='blueLink' href='mailto:incabs-dev@go-mmt.com'> incabs-dev@go-mmt.com</a>"
        }
      ]
    }
  };
  const cabConfigData = await getCabConfiguration();

  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    ...responseData,
    cabConfigData,
    templateData: templateData
  };
};

export default CabsLandingPage;
